import { CrewMember } from '@bechtel/types';

export interface CrewSelectionProps {
  onCrewSelect: (selectedCrewMember: CrewMember, isSourceSelection: boolean) => void;
  selectedCrewMembers: CrewMember[];
  isSourceSelection: boolean;
  moveEntireCrew?: boolean;
  disableSuperintendent?: boolean;
  disableGeneralForeman?: boolean;
}
